import LocationUtil from "@/utils/LocationUtil";

const txMapUtil = {
  key: 'ZAEBZ-JZ26W-E2ARN-YAWD4-6XEBQ-D3B5Z',
  navigate: function (facilityInfo) {
    const baseUrl = 'https://map.qq.com/nav/drive#routes/page?';
    const longitude = facilityInfo.longitude;
    // 起点的名称，默认是“我的位置”
    const sword = "我的位置";
    // 起点的经度，默认是当前定位的经度
    const spointx = LocationUtil.defaultLocation.split(',')[0];
    // 起点的纬度，默认是当前定位的纬度
    const spointy = LocationUtil.defaultLocation.split(',')[1];
    const start = spointx + "," + spointy;

    const eword = facilityInfo.facilityName;
    const epointx = longitude.split(',')[0];
    const epointy = longitude.split(',')[1];
    const dest = epointx + "," + epointy;
    const referer = window.location.host;
    const key = txMapUtil.key;

    const url = baseUrl + "eword=" + eword + "&epointx=" + epointx + "&epointy=" + epointy + "&dest=" + dest + "&key=" + key + "&referer=" + referer + "&sword=" +sword + "&start=" + start + "&spointx=" + spointx + "&spointy=" + spointy;
    // const url = baseUrl + "eword=" + eword + "&epointx=" + epointx + "&epointy=" + epointy + "&dest=" + dest + "&key=" + key + "&referer=" + referer;
    window.location.href = url;
  },
}

export default txMapUtil;
